
import { defineComponent, ref, inject, watch } from "vue";

export default defineComponent({
  name: "ImagesUpdate",
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    watch(() => props.formDataTemp, value => {
      formData.value = {...value}
    })
    const document = ref<string | unknown>("");
    const business = inject("business");
    const newImageAddedLogo = ref<boolean>(false);
    const tempImageLogo = ref<string>("");
    const handleImageUpload = (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (file) => {
        tempImageLogo.value = file?.target?.result as string;
        newImageAddedLogo.value = true;
      };
      const tempEvent = {
        target: {
          name: event.target.name,
          value: file,
        },
      };
      fieldChanged(tempEvent);
    };
    const fieldChanged = (event) => {
      console.log({ event });
      formData.value[event.target.name] = event.target.value;
      emit("form-data", formData.value);
    };
    return {
      document,
      formData,
      fieldChanged,
      handleImageUpload,
      business,
      newImageAddedLogo,
      tempImageLogo,
    };
  },
});
